import { useLocation, Navigate, Outlet } from 'react-router-dom'

const ProtectedRoutes = () => {
  const location = useLocation()
  return localStorage.getItem("token") ? <Outlet /> : <Navigate to="/su/admin/login" replace state={{ from: location }} />
}

export default ProtectedRoutes